<div class="access-denied">
  <img align="middle" alt="" src="assets/images/access-denied.png" />
</div>
